<template>
    <b-modal id="email-modal-btn" :centered="true" no-close-on-backdrop size="sm" class="email-member-modal"
        title="Email Categories" :hide-footer="true" @shown="fetchEmailDomains">
        <form  @submit.prevent="onSubmit">
            <div class="addMemberContent">
                <b-form-group id="input-group-1" label="Email address" label-for="input-1" class="required d-block">
                    <b-form-input id="input-1" type="email" placeholder="Enter Email Address" required v-model="email" disabled></b-form-input>
                </b-form-group>
                <div class="form_checkobox_group mb-2">
                    <label class="form-label-header">Select Email Categories:</label>
                    <div class="d-flex align-items-center flex-wrap mb-1"  
                      v-for="domain in emailDomains"
                       :key="domain.value">
                        <b-form-checkbox :id="`checkbox-${domain.value}`" v-model="selectedDomains" :value="domain.value">
                            {{ domain.text }}

                        </b-form-checkbox>
                        <span class=" d-flex flex-shrink-0 ml-1 icon-wrapper" v-b-tooltip.hover
                        :title="domain.description">
                            <i class="fas fa-info-circle"></i>
                        </span>
                    </div>
                </div>
                <p class="text-infos"><strong>Note:</strong> By selecting any of the checkboxes, you will be included in CC emails for the selected email categories. </p>

            </div>
            <div class="btn-wrapper d-flex justify-content-end mt-4">
                <button type="submit" class="primaryBtn">Apply</button>
            </div>
        </form>
    </b-modal>
</template>
<script>
import axios from "axios";
export default {
    name: "MemberAdminEmail",
      props: {
    email: {
      type: String,
      required: true,
    },
},
    data() {
        return {
            emailDomains: [],
            status: [],
            selectedDomains: [],

        };
    },

    methods: {
        fetchEmailDomains() {
      const url = `email-domains`;
      let loader = this.$loading.show();
      axios.get(url)
        .then((res) => {
          this.emailDomains = res.data.data.map((item) => ({
            text: item.email_category,
            value: item.id,
            description: item.description,
          }));
          this.updateEmailDomains();
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          loader.hide();
        });
    },

      updateEmailDomains() {
      const url = `get-cc-status`;
      let loader = this.$loading.show();
      axios.get(url)
        .then((res) => {
          let data = res.data.data.find((item) => item.email === this.email);
          let updateDomainData = data.domains;
          const checkedDomains = Object.keys(updateDomainData).filter(
            (domain) => updateDomainData[domain] === 1
          );
          this.selectedDomains = this.emailDomains
            .filter((domain) => checkedDomains.includes(domain.text))
            .map((domain) => domain.value);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          loader.hide();
        });
    },

        reset() {
      this.selectedDomains = [];
        this.status = [];

    },
        onSubmit() {
      const selectedDomainsIds = new Set(this.selectedDomains);
      const payload = {
        member_admin_email: this.email,
        domains: this.emailDomains.map((domain) => ({
          email_domain_id: domain.value,
          cc_status: selectedDomainsIds.has(domain.value) ? 1 : 0,
        })),
      };
      this.$emit("onSubmit", payload);
    },

    },
    // created() {
    //   this.fetchEmailDomains();
    //   this.updateEmailDomains();
    // },
    // mounted() {
    //     this.$nextTick(() => {
    //         this.reset();
    //     });
    //     this.fetchEmailDomains();
    //     this.updateEmailDomains();
    // },

};
</script>
